export class FileHelper {

    public static downloadFile(href: string, fileName: string = null): void {

        try {
            const link = document.createElement('a');

            fileName = fileName || '';

            if (fileName) {

                const fileNameExtension = FileHelper.getFileExtension(fileName).toLowerCase();
                const itemPathNameExtension = FileHelper.getFileExtension(href.split('/').pop()).toLowerCase();
                
                if (!fileNameExtension || (fileNameExtension != itemPathNameExtension)) {
                    link.setAttribute('download', fileName + (itemPathNameExtension ? ("." + itemPathNameExtension) : ''));
                } else {
                    link.setAttribute('download', fileName);
                }
            }

            link.setAttribute('target', "_blank");
            link.setAttribute('href', href);
            link.click();

            link.remove();

        } catch (e) {
            console.error("Error downloading file", e);
        }
    }

    public static toBlob(b64Data, sliceSize = 512, contentType = "application/octet-stream") {

        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    public static downloadFileFromBase64(b64Data, fileName: string, contentType = "application/octet-stream"){
        const url = window.URL.createObjectURL(this.toBlob(b64Data, 512, contentType));

        FileHelper.downloadFile(url, fileName);

        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        });
    }

    public static getFileExtension(path: string): string {
        return path && path.indexOf('.') > -1? path.split(/#|\?/)[0].split('.').pop().trim() : '';
    }

    public static async saveAs(getBlob: () => Promise<Blob>, filename: string, types?: FilePickerAcceptType[])
    {
        if (window['showSaveFilePicker']) {
            return await FileHelper.exportNativeFileSystem(getBlob, filename, types);
        }
        else {
            const blob = await getBlob();
            const url = (<any>window["URL"]).createObjectURL(blob);

            FileHelper.downloadFile(url, filename);

            setTimeout(() => {
                window.URL.revokeObjectURL(url);
            });
        }
    }

    private static async exportNativeFileSystem(getBlob: () => Promise<Blob>, filename: string, types: FilePickerAcceptType[] = null)
    {
        const opts: SaveFilePickerOptions = {
            suggestedName: filename
        };
        if(types && types.length > 0)
        {
            opts.types = types;
        }
        const fileHandle: any = await window['showSaveFilePicker'](opts);

        if (!fileHandle) {
            throw new Error('Cannot access filesystem');
        }

        const writer = await fileHandle.createWritable();
        const blob = await getBlob();
        await writer.write(blob);
        await writer.close();
    }
}